import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';

export const OverallWorkExperienceForm = ({ handleChange, handleBlur, values, errors, touched }) => {
  return (
    <div className="signite-form">
      <Row className="mb-3">
        <BSForm.Group as={Col}>
          <BSForm.Label>Work Experience (Years)*</BSForm.Label>
          <BSForm.Control
            type="number"
            name="workExperienceYears"
            min={0}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, 'workExperienceYears')}`}
            value={values.workExperienceYears}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'workExperienceYears')}</span>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>Work Experience(Months)</BSForm.Label>
          <BSForm.Control
            type="number"
            name="workExperienceMonths"
            onChange={handleChange}
            onBlur={handleBlur}
            max={11}
            min={0}
            value={values.workExperienceMonths}
            className={`form-control ${getErrorClass(errors, touched, 'workExperienceMonths')}`}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, 'workExperienceMonths')}</span>
        </BSForm.Group>
        <BSForm.Group as={Col}></BSForm.Group>
      </Row>
    </div>
  );
};
